/** The policy an agent-authored page is rendered under inside a thumbnail.
 *
 *  `sandbox=""` on the iframe is NOT enough on its own, and believing it was is the bug this fixes. Sandbox
 *  stops scripts, forms, plugins and navigation — it does nothing about PASSIVE subresources, so a page
 *  carrying `<img src="https://tracker/…">` or a remote stylesheet still fetches them the moment the card
 *  scrolls into view. That turns a file list into a beacon: whoever authored the file learns when it was
 *  looked at, from which IP.
 *
 *  `default-src 'none'` refuses every remote fetch. The two carve-outs are what keeps the thumbnail a
 *  thumbnail rather than a blank box:
 *   - `style-src 'unsafe-inline'` — a page's own `<style>` block IS its layout, and layout is the whole
 *     reason the preview renders the document instead of its text. Inline CSS ships with the document and
 *     fetches nothing.
 *   - `img-src data:` — an embedded image is part of the file's bytes, again with no request.
 *  Neither permits a network request, which is the property being protected.
 */
export const THUMBNAIL_CSP = "default-src 'none'; style-src 'unsafe-inline'; img-src data:;";

/**
 * An agent-authored page, wrapped so it can be rendered without reaching the network.
 *
 * The meta goes FIRST in the document, because a CSP delivered this way applies only to what the parser has
 * not yet reached — a `<meta>` after an `<img>` would leave that image already requested.
 */
export function sandboxedHtmlDocument(body: string): string {
  return `<!doctype html><meta http-equiv="Content-Security-Policy" content="${THUMBNAIL_CSP}">${body}`;
}
